import type { CreateUnidadMedidaRequest, UpdateUnidadMedidaRequest } from '../types';

export const UNIDAD_MEDIDA_MAX_LEN = 20;

export type UnidadMedidaFormError =
  | 'codigo_obligatorio'
  | 'codigo_max'
  | 'nombre_obligatorio'
  | 'nombre_max';

export const UNIDAD_MEDIDA_ERROR_MSG: Record<UnidadMedidaFormError, string> = {
  codigo_obligatorio: 'El código es obligatorio',
  codigo_max: `El código admite como máximo ${UNIDAD_MEDIDA_MAX_LEN} caracteres`,
  nombre_obligatorio: 'El nombre es obligatorio',
  nombre_max: `El nombre admite como máximo ${UNIDAD_MEDIDA_MAX_LEN} caracteres`,
};

export function isUnidadMedidaAltaRoute(idUnidadMedida?: string | null): boolean {
  return !idUnidadMedida || idUnidadMedida === 'nuevo';
}

export function normalizeUnidadMedidaCodigo(value: string): string {
  return value.trim().toUpperCase();
}

export function normalizeUnidadMedidaNombre(value: string): string {
  return value.trim();
}

export function validateUnidadMedidaForm(input: {
  isNew: boolean;
  codigo: string;
  nombre: string;
}): UnidadMedidaFormError | null {
  const nombre = normalizeUnidadMedidaNombre(input.nombre);
  if (!nombre) return 'nombre_obligatorio';
  if (nombre.length > UNIDAD_MEDIDA_MAX_LEN) return 'nombre_max';

  if (input.isNew) {
    const codigo = normalizeUnidadMedidaCodigo(input.codigo);
    if (!codigo) return 'codigo_obligatorio';
    if (codigo.length > UNIDAD_MEDIDA_MAX_LEN) return 'codigo_max';
  }

  return null;
}

export function buildCreateUnidadMedidaRequest(
  codigo: string,
  nombre: string
): CreateUnidadMedidaRequest {
  return {
    idUnidadMedida: normalizeUnidadMedidaCodigo(codigo),
    descripcion: normalizeUnidadMedidaNombre(nombre),
    cantDecimales: 0,
    usaBalanza: 'NO',
    porcToleranciaPick: null,
  };
}

export function buildUpdateUnidadMedidaRequest(
  codigo: string,
  nombre: string
): UpdateUnidadMedidaRequest {
  return {
    idUnidadMedida: normalizeUnidadMedidaCodigo(codigo),
    descripcion: normalizeUnidadMedidaNombre(nombre),
  };
}

export function labelUnidadMedida(u: {
  idUnidadMedida?: string | null;
  descripcion?: string | null;
}): string {
  const id = String(u.idUnidadMedida ?? '').trim();
  const nombre = String(u.descripcion ?? '').trim();
  if (id && nombre) return `${id} — ${nombre}`;
  return id || nombre;
}

export function toUnidadMedidaSelectOptions(
  items: Array<{ idUnidadMedida: string; descripcion?: string | null }> | null | undefined
): Array<{ value: string; label: string }> {
  return (items ?? []).map((u) => ({
    value: u.idUnidadMedida,
    label: labelUnidadMedida(u),
  }));
}
